import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 32 32",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M7.3333 6.4444H24.6667A2 2 0 0 1 24.6667 10.4444H7.3333A2 2 0 0 1 7.3333 6.4444ZM7.3333 14H24.6667A2 2 0 0 1 24.6667 18H7.3333A2 2 0 0 1 7.3333 14ZM7.3333 21.5556H24.6667A2 2 0 0 1 24.6667 25.5556H7.3333A2 2 0 0 1 7.3333 21.5556Z",
				stroke: "white",
				strokeWidth: 5.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.3333 6.4444H24.6667A2 2 0 0 1 24.6667 10.4444H7.3333A2 2 0 0 1 7.3333 6.4444ZM7.3333 14H24.6667A2 2 0 0 1 24.6667 18H7.3333A2 2 0 0 1 7.3333 14ZM7.3333 21.5556H24.6667A2 2 0 0 1 24.6667 25.5556H7.3333A2 2 0 0 1 7.3333 21.5556Z",
				style: { fill: "var(--sticker-pastel,#D0DBFF)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.3333 6.4444H24.6667A2 2 0 0 1 24.6667 10.4444H7.3333A2 2 0 0 1 7.3333 6.4444ZM7.3333 14H24.6667A2 2 0 0 1 24.6667 18H7.3333A2 2 0 0 1 7.3333 14ZM7.3333 21.5556H24.6667A2 2 0 0 1 24.6667 25.5556H7.3333A2 2 0 0 1 7.3333 21.5556Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				style: { stroke: "var(--sticker-dark,#505772)" }
			})
		]
	});
};
export default SvgMenu;
